import { createSlice } from "@reduxjs/toolkit";
import { api } from "../../services/rtk/api.js";

const initialState = {
  posts: [],
  selectedPost: null,
  isLoading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setSelectedPost: (state, action) => {
      state.selectedPost = action.payload;
    },
    clearDashboardError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get posts
      .addMatcher(api.endpoints.getPosts.matchPending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(
        api.endpoints.getPosts.matchFulfilled,
        (state, { payload }) => {
          state.posts = payload;
          state.isLoading = false;
          state.error = null;
        }
      )
      .addMatcher(
        api.endpoints.getPosts.matchRejected,
        (state, { payload }) => {
          state.isLoading = false;
          state.error = payload?.data || "Failed to fetch posts";
        }
      )

      // Get single post
      .addMatcher(api.endpoints.getPost.matchPending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(
        api.endpoints.getPost.matchFulfilled,
        (state, { payload }) => {
          state.selectedPost = payload;
          state.isLoading = false;
          state.error = null;
        }
      )
      .addMatcher(api.endpoints.getPost.matchRejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.data || "Failed to fetch post";
      });
  },
});

export const { setSelectedPost, clearDashboardError } = dashboardSlice.actions;
export default dashboardSlice.reducer;
